/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================= Breeze ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = "slim";
var klevu_productsToShowInSlimLayout = 6;

klevu.beforeActivation("quick", function (data, scope) {
  klevu.each(klevu.search.extraSearchBox, function (key, box) {
    box
      .getScope()
      .template.setTemplate(
        klevuQuickProductBlockTitleHeaderCustom,
        "klevuQuickProductBlockTitleHeader",
        true
      );
    box
      .getScope()
      .template.setTemplate(
        klevuQuickProductBlockCustom,
        "klevuQuickProductBlock",
        true
      );
    box
      .getScope()
      .template.setTemplate(
        klevuQuickTemplateBaseCustom,
        "klevuTemplateBase",
        true
      );
    box
      .getScope()
      .template.setTemplate(
        klevuQuickTrendingProductBlockCustom,
        "klevuQuickTrendingProductBlock",
        true
      );
    box
      .getScope()
      .template.setTemplate(
        klevuQuickRecentViewedProductBlockCustom,
        "klevuQuickRecentViewedProductBlock",
        true
      );
    box
      .getScope()
      .template.setTemplate(
        klevuSearchPersonalizationsCustom,
        "klevuSearchPersonalizations",
        true
      );
  });
});

klevu.afterTemplateRender("quick", function (data, scope) {
  function setKlevuQuickPopupTopPositionVariable() {
    klevu.each(
      klevu.dom.find(".kuQuickSearchAutoCompleteLayout .klevuWrap"),
      function (key, currentElement) {
        const topPosition = currentElement.getBoundingClientRect().top;
        document.documentElement.style.setProperty(
          "--klevuQuickPopupTopPosition",
          `${topPosition}px`
        );
      }
    );
  }
  setKlevuQuickPopupTopPositionVariable();
  window.addEventListener("resize", setKlevuQuickPopupTopPositionVariable);
});
/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickProductBlockTitleHeaderCustom = `
<div class="klevuSuggestionHeading">
    <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
    </div>
    <div class="klevuProductsViewAll">
    <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
    <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View All")%></a>
</div>`;

var klevuQuickProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
            </div>
        </div>
        <div class="klevuProductItemBottom">
            <div class="klevuQuickProductDescBlock">
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                            <% if(quickFacetedLayoutMessage != "") { %>
                                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                            <% } %>                    
                        <% } else { %>
                            <% if(data.query.productList) { %>
                                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                                <%= helper.render('klevuQuickProducts',scope) %>
                                <%= helper.render('klevuQuickOtherContent',scope) %>
                            <% } else { %>              
                                <div class="kuSearchPersonalizationsContainer">
                                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                                </div>
                            <% } %>  
                        <% } %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
        </div>
    </div>
</div>`;

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
    updatedProductName = updatedProductName.replace(dataLocal.brand, '');
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
    </div>
</div>
<div class="klevuProductItemBottom">
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickRecentViewedProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
    <div class="klevuProductItemTop">
        <div class="klevuQuickImgWrap">
            <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
            <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
        </div>
    </div>
    <div class="klevuProductItemBottom">
        <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
            <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
        <div class="klevuQuickProductDescBlock">
            <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
            <div class="klevuQuickProductDesc">
                <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div> <div class="klevuQuickProductPrice">
                <%
                    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                %>
                <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                    <div class="klevuQuickSalePrice kuStartPrice">
                        <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                        <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                    </div>
                <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                    <span class="klevuQuickOrigPrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                    <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                        <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                    </span>
                <% } else if(!Number.isNaN(kuSalePrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                    </span>
                <% } else if(!Number.isNaN(kuPrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                <% } %>
            </div>
            </div>                
        </div>
    </div>        
</a>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
<section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
    <div ku-block data-block-id="ku_quick_left_facets"></div>
    <div ku-block data-block-id="ku_quick_left_call_outs">
        <%=helper.render('kuTemplatePopularSearches',scope) %>
        <%=helper.render('kuTemplateRecentSearches',scope) %>
    </div>
    <% if (window.innerWidth >= 768) { %>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    <% } %>
</section>
<section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
    <header ku-block data-block-id="ku_quick_result_header"></header>
    <div ku-block data-block-id="ku_quick_result_items"></div>
                
    <div ku-block data-block-id="ku_quick_other_items">
        <%=helper.render('klevuTrendingProducts',scope) %>
        <% if (window.innerWidth < 768) { %>
            <div ku-block data-block-id="ku_quick_left_banner"></div>
        <% } %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
    </div>

    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
</section>
<section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
    <div ku-block data-block-id="ku_quick_right_facets"></div>
    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
    <div ku-block data-block-id="ku_quick_right_banner"></div>
</section>
</div>`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ======================== Haven ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = "left";

klevu.beforeActivation("landing", function (data, scope) {
  scope.kScope.template.setTemplate(
    klevuLandingTemplateFiltersCustom,
    "filters",
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplateResultsCustom,
    "results",
    true
  );
  scope.kScope.template.setTemplate(
    klevuLandingTemplatePaginationCustom,
    "pagination",
    true
  );

  scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

  (function (klevu) {
    klevu.extend(true, klevu.search.modules, {
      addParamsToURL: {
        base: {
          addURLtoHistory: function (data, scope, queryId) {
            // Global stuff
            if (
              typeof window.history === "undefined" ||
              typeof window.history.pushState === "undefined"
            ) {
              console.error(
                "This browser does not have the support of window.history or window.history.pushState"
              );
              return;
            }

            var searchPath = new URLSearchParams(window.location.search);
            var currentSearchPath;
            var previousSearchPath = searchPath.toString();

            // this is in case we're running our code where we dont have context.activeQueryId
            var activeQueryId = klevu.getObjectPath(
              data,
              "context.activeQueryId"
            );
            if (queryId && queryId.length) {
              activeQueryId = queryId;
            }

            // Check if there any filter selected
            let applyFilters =
              typeof data.localOverrides.query[activeQueryId].filters !==
              "undefined"
                ? data.localOverrides.query[activeQueryId].filters.applyFilters
                : {};
            let isThereFiltersSelected = false;
            // Check if applyFilters is an object (but not an array), and not empty
            if (
              typeof applyFilters === "object" &&
              !Array.isArray(applyFilters) &&
              applyFilters !== null &&
              Object.keys(applyFilters).length > 0
            ) {
              isThereFiltersSelected = true;
            }

            // PAGINATION TO URL
            var hasPaginationEnabled = klevu.getSetting(
              klevu,
              "settings.theme.modules.pagination.searchResultsPage.enable"
            );
            var paginationQueryParam = "Page";
            var currentPage = 0;

            if (hasPaginationEnabled) {
              var activeQueryMeta = klevu.getObjectPath(
                data,
                "template.query." + activeQueryId + ".meta"
              );
              if (activeQueryMeta) {
                var productListLimit = activeQueryMeta.noOfResults;
                currentPage =
                  Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
              }

              if (currentPage === 0 || currentPage === 1) {
                searchPath.delete(paginationQueryParam);
              } else {
                searchPath.set(paginationQueryParam, currentPage);
              }

              currentSearchPath = searchPath.toString();
            }

            // FILTERS TO URL
            var activeQueryFilters = klevu.getObjectPath(
              data,
              "template.query." + activeQueryId + ".filters"
            );
            var filterValuesQueryParam = "";

            if (activeQueryFilters) {
              klevu.each(activeQueryFilters, function (key, filter) {
                var selectedFilterKeyString = "";
                var filterOptions = filter.options;
                var selectedValues = "";

                if (filterOptions && filterOptions.length) {
                  klevu.each(filterOptions, function (key, option) {
                    if (option.selected === true) {
                      if (selectedValues.length) {
                        selectedValues += ",";
                      }
                      selectedValues += option.value;
                    }
                  });
                } else if (filter.type === "SLIDER") {
                  var startValue = filter.start;
                  var endValue = filter.end;
                  var minValue = filter.min;
                  var maxValue = filter.max;
                  if (
                    typeof startValue !== "undefined" &&
                    startValue !== null &&
                    typeof endValue !== "undefined" &&
                    endValue !== null
                  ) {
                    if (
                      Number(startValue) === Number(minValue) &&
                      Number(endValue) === Number(maxValue)
                    ) {
                      // just skipping
                    } else {
                      selectedValues = startValue + "-" + endValue;
                    }
                  }
                }

                if (selectedValues.length) {
                  // selectedFilterKeyString += filter.key + ":" + selectedValues;
                  selectedFilterKeyString +=
                    encodeURIComponent(filter.key) +
                    ":" +
                    encodeURIComponent(selectedValues);
                }

                if (selectedFilterKeyString.length) {
                  if (filterValuesQueryParam.length) {
                    filterValuesQueryParam += ";";
                  }
                  filterValuesQueryParam += selectedFilterKeyString;
                }
              });
            }

            if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
              searchPath.set("Filters", filterValuesQueryParam);
            } else {
              searchPath.delete("Filters");
            }

            currentSearchPath = searchPath.toString();

            // ==============================
            // Final URL change
            if (previousSearchPath !== currentSearchPath) {
              var historyState = {
                page: currentPage,
                filters: currentSearchPath,
              };
              window.history.pushState(
                historyState,
                null,
                currentSearchPath
                  ? "?" + currentSearchPath
                  : window.location.pathname
              );
            }
          },

          restoreSearchParamsOnPageLoad: function (data, scope) {
            var hasAlreadyTriggered = klevu.getObjectPath(
              scope.kScope,
              "element.kScope.getAndUpdateFiltersTriggered"
            );
            if (hasAlreadyTriggered) return;

            var activeQueryId =
              klevu.getObjectPath(data, "context.activeQueryId") ||
              "productList";

            var filtersFromURL =
              klevu.dom.helpers.getQueryStringValue("Filters");
            var paginationFromURL =
              klevu.dom.helpers.getQueryStringValue("Page");

            var matchedQueryParamId = "";
            var matchedQueryParamValue = "";
            var recordQueries = klevu.getObjectPath(
              data,
              "request.current.recordQueries"
            );

            if (recordQueries && recordQueries.length) {
              klevu.each(recordQueries, function (key, recordQuery) {
                if (recordQuery.id) {
                  if (
                    (paginationFromURL && paginationFromURL.length) ||
                    (filtersFromURL && filtersFromURL.length)
                  ) {
                    matchedQueryParamId = recordQuery.id;
                    matchedQueryParamValue =
                      paginationFromURL || filtersFromURL;
                  }
                }
              });
            }

            klevu.setObjectPath(
              scope.kScope,
              "element.kScope.getAndUpdateFiltersTriggered",
              true
            );

            matchedQueryParamId = activeQueryId || "productList";

            if (matchedQueryParamId.length && matchedQueryParamValue.length) {
              activeQueryId = matchedQueryParamId;
              var storage = klevu.getSetting(
                scope.kScope.settings,
                "settings.storage"
              );
              if (storage.tabs) {
                storage.tabs.setStorage("local");
                storage.tabs.mergeFromGlobal();
                storage.tabs.addElement("active", activeQueryId);
                storage.tabs.mergeToGlobal();
              }
            }

            if (paginationFromURL && paginationFromURL > 1) {
              if (recordQueries && recordQueries.length) {
                klevu.each(recordQueries, function (key, recordQuery) {
                  if (recordQuery.id === activeQueryId) {
                    var limit = klevu.getObjectPath(
                      recordQuery,
                      "settings.limit"
                    );
                    limit = Number(limit);
                    if (limit > 0) {
                      var expectedOffset = (paginationFromURL - 1) * limit;
                      klevu.setObjectPath(
                        data,
                        "localOverrides.query." +
                          activeQueryId +
                          ".settings.offset",
                        expectedOffset
                      );
                    }
                  }
                });
              }
            }

            // FILTERS
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(";");
              if (facets) {
                klevu.each(facets, function (key, facet) {
                  var splitFacet = facet.split(":");
                  if (splitFacet.length) {
                    var facetKey = decodeURIComponent(splitFacet[0]);
                    var facetValues = decodeURIComponent(splitFacet[1]).split(
                      ","
                    );
                    var applyFilters = klevu.getObjectPath(
                      data,
                      "localOverrides.query." +
                        activeQueryId +
                        ".filters.applyFilters.filters"
                    );

                    if (applyFilters && applyFilters.length) {
                      // if there're some filters
                      var isExistingKey = false;
                      klevu.each(applyFilters, function (key, applyFilter) {
                        if (applyFilter.key === facetKey) {
                          isExistingKey = true;
                          klevu.each(facetValues, function (key, facetValue) {
                            var isFilterOptionMatched = false;
                            klevu.each(
                              applyFilter.values,
                              function (key, value) {
                                if (facetValue === value) {
                                  isFilterOptionMatched = true;
                                }
                              }
                            );
                            if (!isFilterOptionMatched) {
                              applyFilter.values.push(facetValue);
                            }
                          });
                        }
                      });
                      if (!isExistingKey) {
                        applyFilters.push({
                          key: facetKey,
                          values: facetValues,
                        });
                      }
                    } else {
                      klevu.setObjectPath(
                        data,
                        "localOverrides.query." +
                          activeQueryId +
                          ".filters.applyFilters.filters",
                        [{ key: facetKey, values: facetValues }]
                      );
                    }
                  }
                });
              }
            }
          },

          updatePayloadOnPopState: function (data, scope, activeQueryId) {
            // SET PAGINATION PAYLOAD
            var paginationFromURL =
              klevu.dom.helpers.getQueryStringValue("Page");
            paginationFromURL = Number(paginationFromURL);
            var limit =
              window.klevuCurrentScope.element.kObject.getScope().data.request
                .original.queryRequest[0].settings.limit;
            limit = Number(limit);
            if (limit > 0) {
              var expectedOffset =
                (paginationFromURL - 1) * limit > 0
                  ? (paginationFromURL - 1) * limit
                  : 0;
              klevu.setObjectPath(
                data,
                "localOverrides.query." + activeQueryId + ".settings.offset",
                expectedOffset
              );
              // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
            }

            // SET FILTER PAYLOAD
            var filtersFromURL =
              klevu.dom.helpers.getQueryStringValue("Filters");
            if (filtersFromURL && filtersFromURL.length) {
              var facets = filtersFromURL.split(";");
              // loop through all facets to get its values
              let facetKey = "";
              let facetValues = [];
              let facetsArray = [];

              klevu.each(facets, function (key, facet) {
                var splitFacet = facet.split(":");
                if (splitFacet.length) {
                  facetKey = decodeURIComponent(splitFacet[0]);
                  facetValues = decodeURIComponent(splitFacet[1]).split(",");
                  facetsArray.push({ key: facetKey, values: facetValues });
                }
              });
              // set the payload with correct filters:
              klevu.setObjectPath(
                data,
                "localOverrides.query." +
                  activeQueryId +
                  ".filters.applyFilters.filters",
                facetsArray
              );
            } else {
              // reset filters if Back button pressed, and there's no filters
              klevu.setObjectPath(
                data,
                "localOverrides.query." +
                  activeQueryId +
                  ".filters.applyFilters.filters",
                []
              );
            }
          },
        },
        build: true,
      },
      keepFacetsWithSelectedOptionsOpened: function (data, scope) {
        const selectors = {
          kuFilterBox: ".kuFilterBox",
          kuSelected: ".kuSelected",
          kuFilterNames: ".kuFilterNames",
          kuFilterNamesCollapse: ".kuFilterNames.kuFilterCollapse",
          kuFilterHead: ".kuFilterHead",
          kuFilterHeadExpand: ".kuFilterHead.kuExpand",
          kuExpand: ".kuExpand",
          kuCollapse: ".kuCollapse",
          nouiElement: ".noUi-origin",
          priceFacetBlock: '[data-filter="klevu_price"]',
          kuFilterShowAll: ".kuFilterShowAll",
          kuFilterCollapse: ".kuFilterCollapse",
        };

        /** Collapse Filters by default */
        (function collapseAllFilters() {
          // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
          const kuFilterHeadElements = document.querySelectorAll(
            selectors.kuFilterHead
          );
          kuFilterHeadElements.forEach((element) => {
            element.classList.add(selectors.kuExpand.substring(1));
            element.classList.remove(selectors.kuCollapse.substring(1));
          });

          // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
          const kuFilterNamesElements = document.querySelectorAll(
            selectors.kuFilterNames
          );
          kuFilterNamesElements.forEach((element) => {
            element.classList.add(selectors.kuFilterCollapse.substring(1));
            element.classList.remove(selectors.kuFilterShowAll.substring(1));
          });
        })();

        // Regular checkbox-facets
        // Check if the required elements exist
        const kuSelectedElements = document.querySelectorAll(
          selectors.kuFilterBox + " " + selectors.kuSelected
        );
        if (kuSelectedElements.length > 0) {
          kuSelectedElements.forEach((selectedElement) => {
            // Find the parent element with the class kuFilterBox
            const filterBoxParent = findParentWithClass(
              selectedElement,
              selectors.kuFilterBox
            );

            // Look for the child with the class kuFilterHead.kuExpand
            const filterHeadChild = filterBoxParent.querySelector(
              selectors.kuFilterHeadExpand
            );

            // Rotate icon in the title
            if (filterHeadChild) {
              filterHeadChild.classList.remove("kuExpand");
              filterHeadChild.classList.add("kuCollapse");
            }

            // Find the parent element with the class kuFilterNames.kuFilterCollapse
            const filterNamesParent = findParentWithClass(
              selectedElement,
              selectors.kuFilterNamesCollapse
            );

            // Show options
            if (filterNamesParent) {
              filterNamesParent.classList.remove("kuFilterCollapse");
              filterNamesParent.classList.add(
                selectors.kuFilterShowAll.substring(1)
              );
            }
          });
        }

        // Price slider facet
        var isThereAnyAppliedFacets = klevu.getObjectPath(
          scope.kScope.data,
          "localOverrides.query." +
            scope.kScope.data.context.activeQueryId +
            ".filters.applyFilters.filters"
        );
        const isPriceFacetApplied = Boolean(
          isThereAnyAppliedFacets?.filter((val) => val.key === "klevu_price")
            .length
        );
        if (isPriceFacetApplied) {
          // Find the parent element with the class kuFilterNames.kuFilterCollapse
          const nouiElement = document.querySelector(
            `${selectors.priceFacetBlock} ${selectors.nouiElement}`
          );

          if (nouiElement) {
            const filterNamesParent = findParentWithClass(
              nouiElement,
              selectors.kuFilterNamesCollapse
            );

            // Show options
            if (filterNamesParent) {
              filterNamesParent.classList.remove("kuFilterCollapse");
              filterNamesParent.classList.add(
                selectors.kuFilterShowAll.substring(1)
              );
            }

            // Find the parent element with the class kuFilterBox
            const filterBoxParent = findParentWithClass(
              nouiElement,
              selectors.kuFilterBox
            );

            // Look for the child with the class kuFilterHead.kuExpand
            const filterHeadChild = filterBoxParent.querySelector(
              selectors.kuFilterHeadExpand
            );

            // Rotate icon in the title
            if (filterHeadChild) {
              filterHeadChild.classList.remove("kuExpand");
              filterHeadChild.classList.add("kuCollapse");
            }
          }
        }

        // Function-helper to find the parent element with a specified class
        function findParentWithClass(element, className) {
          let parent = element.parentElement;
          while (parent) {
            if (parent.matches(className)) {
              return parent;
            }
            parent = parent.parentElement;
          }
          return null; // No matching parent found
        }
      },
      smoothScrollToProductListingTop: function () {
        let customOffset = 150;
        const selectorsToTriggerScrollToTop = {
          pagination: ".kuPagination a",
          // filterOptions: '.klevuFilterOption',
          // Add more selectors here as needed
        };
        function _smoothScrollToKlevuTop() {
          setTimeout(function () {
            var target = document.getElementsByClassName("klevuMeta")[0];

            if (target) {
              var topPosition =
                target.getBoundingClientRect().top + window.pageYOffset;

              window.scrollTo({
                top: topPosition - customOffset,
                behavior: "smooth",
              });
            }
          }, 100);
        }
        Object.values(selectorsToTriggerScrollToTop).forEach((selector) => {
          document
            .querySelectorAll(selector)
            .forEach((el) =>
              el.addEventListener("click", _smoothScrollToKlevuTop)
            );
        });
      },
      filterToggler: function (data, scope) {
        try {
          const documentBody = document.body;
          function clickHandler({ target }) {
            if (target.matches("#ku-filter-toggler, #ku-filter-toggler *")) {
              documentBody.classList.add("klevu-filters-opened");
            } else if (
              target.matches(
                ".klevu-facet-buttons__button-apply, .klevu-facet-buttons__button-apply *, [data-container-role=left], #kuFilterClose, #kuFilterClose *"
              )
            ) {
              documentBody.classList.remove("klevu-filters-opened");
            }
          }
          // Check if the listener has been attached using a data attribute
          if (!documentBody.dataset.klevuMobileFiltersClickListenerAttached) {
            klevu.event.attach(documentBody, "click", clickHandler);

            // Set the data attribute to indicate that the listener has been attached
            documentBody.dataset.klevuMobileFiltersClickListenerAttached =
              "true";
          }
        } catch (err) {}
      },
      isThisPageCategory: function () {
        const isThisPageCategory = !klevu.getSetting(
          klevu,
          "settings.flags.setRemoteConfigLanding.build"
        );
        const documentBody = document.body;

        if (isThisPageCategory && documentBody) {
          documentBody.classList.add("klevu-category-page");
        }
      },
    });
  })(klevu);
});

klevu.afterTemplateRender("landing", function (data, scope) {
  klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
  klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
  klevu.search.modules.smoothScrollToProductListingTop(data, scope);
  klevu.search.modules.filterToggler(data, scope);
  klevu.search.modules.isThisPageCategory(data, scope);
});

klevu.modifyRequest("landing", function (data, scope) {
  // Restore Search Params On Page Load
  klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(
    data,
    scope
  );

  // set the global scope
  window.klevuCurrentScope = scope.kScope;

  klevu.each(data.request.current.recordQueries, function (key, query) {
    klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);

    // No results limit
    const queryID = klevu.getObjectPath(query, "id");
    if (queryID === "noResultsFoundPopularProductList") {
      klevu.setObjectPath(query, "settings.limit", 8);
    }
    // No results limit END
  });
});

window.onpopstate = function (event) {
  try {
    // passing activeQueryId because it's lost once we reset the data below
    var activeQueryId = klevu.getObjectPath(
      window.klevuCurrentScope.element.kObject.getScope().data,
      "context.activeQueryId"
    );
    // code to get ready to reset all the data
    var data = window.klevuCurrentScope.element.kObject.getScope().data;
    var scope = window.klevuCurrentScope.element;
    scope.kScope.data = scope.kObject.resetData(scope.kElem);
    scope.kScope.data.context.keyCode = 0;
    scope.kScope.data.context.eventObject = event;
    scope.kScope.data.context.event = "keyUp";
    scope.kScope.data.context.preventDefault = false;

    // Get payload for Filters & Pagination
    klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(
      data,
      scope,
      activeQueryId
    );

    // Fire request, re-render results
    klevu.event.fireChain(
      scope.kScope,
      "chains.events.keyUp",
      scope,
      scope.kScope.data,
      event
    );
  } catch (error) {
    console.log(error);
  }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>    
    <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">


        <div class="kuFilters__header">
            <h3 class="kuFiltersTitleHeading"><%=helper.translate("Filter By")%></h3>
            <button id="kuFilterClose">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15" height="15" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"><path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z"/></svg>
            </button>            
        </div>



        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
        <% filter.isCollapsed = true; %>
            <% if(filter.type == "OPTIONS"){ %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames ">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text"><%=filterOption.name%></span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 5 ) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames  sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                        <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                            <div data-querykey = "<%=dataLocal%>" data-filterkey="<%=filter.key%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                        </div>
                    </div>
                </div>
            <% } else if (filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames  <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>
        



        <div class="klevu-facet-buttons">
            <button class="klevu-facet-buttons__button klevu-facet-buttons__button-clear">
                <span class="kuFilterTagClearAll klevu-facet-buttons__text" title="<%= helper.translate('Clear Filters') %>"><%= helper.translate('Clear All') %></span>
            </button>
            <button class="klevu-facet-buttons__button klevu-facet-buttons__button-apply">
                <span class="klevu-facet-buttons__text"><%= helper.translate("Apply Filters")%></span>
            </button>
        </div>
        
        
        
        
        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
        </div> -->

        <!-- <button id="kuFilterClose">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15" height="15" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"><path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z"/></svg>
        </button> -->
    </div>
<% } %>`;

var klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">                                
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                            <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                            <button id="ku-filter-toggler">
                                <svg style="pointer-events:none;" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                                    <image width="128" height="128" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAA9pJREFUeJzt3c1R20AYxvEnH/foyC1KBZAKonRAB7iD0AHuIKQCnAoMFSBOOUIqQKkAuQJyWHmGMbtCkl+vvv6/mR0YGUuvvavdlex9kQAAAAAAAAAAAAAAAABgrBJJPyStJT3vlHX1WNJbdDioC0lPel3xu+Wp+ltMRCL/Gf9WWYveYBK6VP7LRoARW6p75W/LMnLMMJKq2ZjfZE6QRo0cJi61f+Vvy2Xk2KN5V/NYKumbht/6N/JX0KPsYi8kffFsP5f0yegYh1JIuqt+NpbJpvuMUfLAa7A+jk8+gNffdBjLfC/gfeCFLTXuS6BsJPuMJVFgMhtqAGOufLQQagCrmEEcwMNI9hnTtW/jx8AfX0oqJZ1q+L2Br2JKucmh1QRtU+2zybGHppSr/FXPcUS3kt0kahU1cpjIZNcAsqiRw0yu/SvfO3ZiHBK5MbBr5Rca/hwIbzhRt0ZQVs/FBCRqNxzk4syfpFO5Mb1uvM/6Cq4PdR8GTVki171vz/JS7pred60PAAAAAAAAAAAAACM014+DhyiRdFz9ftdnIIgnk3Ql/zrMR0k/NfzFueggkXSr5gs7L/oJE4dwom4rr8lZNAGJ9lt2fxU/ZFhq2u3XlWXsoGHjVPtX/nZOwFAwQrlsGsCzXGoaE3X3ATK5HEFo559erybejv1WbuR6lF2hq4U7hVPpeFl1V3MsS8/7mR3gOD51S+B8DSaYIcSsi4GkeGN2XcIKb52GGgBmItQAJpsYsSexlpwd1zzmrdNQjqBrSd81s4WSRgrPNutcQjeB7b8C23O1nATCXq4BXgYiHqsrq1LcCBqtXJz9s7ZvzqJV9IhhrmvOomvR9U9Gm5xFpfgEcLIyuW7d1yMUctfu6SED4Euhw7HNWyRxzQ4AAAAAAAAAAABgb0P5ODiV9Ln6WVTbyJMzA2eS7hX+NsxarE2YpBO5JEhNvw9HepQJWahbmpR70QhGr2uCpJeNAIY+RD7eH0lHezz/SG7imptEg6gWslka9SSSJ45S3Wyf5VE9qbsPcCa3oLHtxOuvXldQKjfrt/Ig6atn+63hMaailFtV9LvNk87V/excevaX7bG/UPEpDnCcqZRWKWLOAtu7So33F1JEOs4YtUoStTE+OP+Ve6BCDWCp7o3AN2ewbgCh2Opy5MzZRoEFpqEcQbncTZtM7bvvIrA/S6H9hXLkzFkh934VvUYhNxO1mtAs4oYOC5lsKr+IGzYsWfQC3tksxiGRu4nTtfJJYDkBXRsBlT8hidxlSdMxn25/olK5W5S7PcL2/vWir8AAAAAAAAAAAAAAAAAAYHz+Ay8t1mZnuutoAAAAAElFTkSuQmCC" id="img_1" />
                                    <use xlink:href="#img_1" fill="#FFFFFF" stroke="none" transform="scale(0.109375 0.109375)" />
                                </svg>
                                Filters
                            </button>
                            
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                                <%=helper.render('limit',scope,data,"productList") %>
                                <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                <%=helper.render('productBlock',scope,data,item) %>
                                            <% } %>
                                        <% }); %>
                                    </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>

                        <%=helper.render('pagination',scope,data,"productList") %>
                        
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>

                </div>
                
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <button id="ku-filter-toggler">
                                    <svg style="pointer-events:none;" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                                        <image width="128" height="128" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAA9pJREFUeJzt3c1R20AYxvEnH/foyC1KBZAKonRAB7iD0AHuIKQCnAoMFSBOOUIqQKkAuQJyWHmGMbtCkl+vvv6/mR0YGUuvvavdlex9kQAAAAAAAAAAAAAAAABgrBJJPyStJT3vlHX1WNJbdDioC0lPel3xu+Wp+ltMRCL/Gf9WWYveYBK6VP7LRoARW6p75W/LMnLMMJKq2ZjfZE6QRo0cJi61f+Vvy2Xk2KN5V/NYKumbht/6N/JX0KPsYi8kffFsP5f0yegYh1JIuqt+NpbJpvuMUfLAa7A+jk8+gNffdBjLfC/gfeCFLTXuS6BsJPuMJVFgMhtqAGOufLQQagCrmEEcwMNI9hnTtW/jx8AfX0oqJZ1q+L2Br2JKucmh1QRtU+2zybGHppSr/FXPcUS3kt0kahU1cpjIZNcAsqiRw0yu/SvfO3ZiHBK5MbBr5Rca/hwIbzhRt0ZQVs/FBCRqNxzk4syfpFO5Mb1uvM/6Cq4PdR8GTVki171vz/JS7pred60PAAAAAAAAAAAAACM014+DhyiRdFz9ftdnIIgnk3Ql/zrMR0k/NfzFueggkXSr5gs7L/oJE4dwom4rr8lZNAGJ9lt2fxU/ZFhq2u3XlWXsoGHjVPtX/nZOwFAwQrlsGsCzXGoaE3X3ATK5HEFo559erybejv1WbuR6lF2hq4U7hVPpeFl1V3MsS8/7mR3gOD51S+B8DSaYIcSsi4GkeGN2XcIKb52GGgBmItQAJpsYsSexlpwd1zzmrdNQjqBrSd81s4WSRgrPNutcQjeB7b8C23O1nATCXq4BXgYiHqsrq1LcCBqtXJz9s7ZvzqJV9IhhrmvOomvR9U9Gm5xFpfgEcLIyuW7d1yMUctfu6SED4Euhw7HNWyRxzQ4AAAAAAAAAAABgb0P5ODiV9Ln6WVTbyJMzA2eS7hX+NsxarE2YpBO5JEhNvw9HepQJWahbmpR70QhGr2uCpJeNAIY+RD7eH0lHezz/SG7imptEg6gWslka9SSSJ45S3Wyf5VE9qbsPcCa3oLHtxOuvXldQKjfrt/Ig6atn+63hMaailFtV9LvNk87V/excevaX7bG/UPEpDnCcqZRWKWLOAtu7So33F1JEOs4YtUoStTE+OP+Ve6BCDWCp7o3AN2ewbgCh2Opy5MzZRoEFpqEcQbncTZtM7bvvIrA/S6H9hXLkzFkh934VvUYhNxO1mtAs4oYOC5lsKr+IGzYsWfQC3tksxiGRu4nTtfJJYDkBXRsBlT8hidxlSdMxn25/olK5W5S7PcL2/vWir8AAAAAAAAAAAAAAAAAAYHz+Ay8t1mZnuutoAAAAAElFTkSuQmCC" id="img_1" />
                                        <use xlink:href="#img_1" fill="#FFFFFF" stroke="none" transform="scale(0.109375 0.109375)" />
                                    </svg>
                                    Filters
                                </button>
                                
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                
                                <% if(helper.hasResults(data,"contentList")) { %>
                                    <%=helper.render('limit',scope,data,"contentList") %>
                                <% } %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            
                            <%=helper.render('pagination',scope,data,"contentList") %>

                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    <% } %> 

</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var resultsPerPage = data.query[dataLocal].meta.noOfResults;
        var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
        const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
        const currentOffsetNumber = data.query[dataLocal].meta.offset;
        const currentPage = (Math.ceil(currentOffsetNumber/resultsPerPage)+1);
        const customOffsetPrev = currentPage <= 1 ? 0 : (resultsPerPage * (currentPage - 2));
        const customOffsetNext = (currentOffsetNumber + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffsetNumber + (resultsPerPage));
        const productListLimit = data.query.productList.meta.noOfResults;
        const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
        const isLastPage = currentPage === totalPages;
        const productListTotal = data.query.productList.meta.totalResultsFound - 1;
        const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
    %>
    
    <div class="kuPagination kuPagination--custom">
        <div class="klevuPaginate-wrapper">

            <% if(currentOffsetNumber > 0) { %>
                <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>">
                    <svg style="pointer-events: none;" focusable="false" width="24" height="24" viewBox="2 2 24 24" role="img" aria-label="Previous Page" data-hb-id="pl-icon">
                        <title>Previous Page</title>
                        <path d="M21 13.5H8.21l5.14-5.15a.49.49 0 00-.7-.7l-6 6a.36.36 0 00-.11.16.5.5 0 000 .38.36.36 0 00.11.16l6 6a.48.48 0 00.7 0 .48.48 0 000-.7L8.21 14.5H21a.5.5 0 000-1z"></path>
                    </svg>
                </a>
            <% } %>

            <% if (currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage === 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage === 4) {  %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-2)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage >= 5) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 4))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-2)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            
            <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+1)%></a>

            <% if(totalResultsFound >= currentOffsetNumber + resultsPerPage) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+2)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+4)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 4))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+5)%></a>
            <% } %>
            <% if (totalPages - currentPage === 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+4)%></a>
            <% } %>
            <% if (totalPages - currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
            <% } %>

            <% if(totalResultsFound >= currentOffsetNumber + resultsPerPage && totalPages > 1) { %>
                <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>">
                    <svg style="pointer-events: none;" focusable="false" width="24" height="24" viewBox="2 2 24 24" role="img" aria-label="Next" data-hb-id="pl-icon">
                        <title>Next</title>
                        <path d="M21.46 14.19a.5.5 0 000-.38.36.36 0 00-.11-.16l-6-6a.49.49 0 00-.7.7l5.14 5.15H7a.5.5 0 000 1h12.79l-5.14 5.15a.48.48 0 000 .7.48.48 0 00.7 0l6-6a.36.36 0 00.11-.16z"></path>
                    </svg>
                </a>
            <% } %>

        </div>
    </div>

<% } %>`;
